export default __webpack_public_path__ + "static/image4-9660d39ff599cc31000c4c8efbce2cbc.jpg";